import { render, staticRenderFns } from "./InductionTable.vue?vue&type=template&id=521dbf7e&"
import script from "./InductionTable.vue?vue&type=script&lang=js&"
export * from "./InductionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports